"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.TitlesPage = void 0;
require("./TitlesPage.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _GridContainer = _interopRequireDefault(require("../GridContainer/GridContainer"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * TitlesPage component
 *
 * @method
 * @param { TitlesPageProps} props
 * @returns TitlesPage
 */

const TitlesPage = props => {
  const {
    externalAction,
    headline,
    headlineTag = defaultProps.headlineTag,
    linkAction,
    subheadline
  } = props;
  if (!headline) {
    return null;
  }
  const hasAction = linkAction?.label || externalAction;
  const componentClassName = (0, _classnames.default)('pal-c-TitlesPage', {});
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, null, headline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesPage__body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesPage__body--headline"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "title-xlg",
    htmlTag: headlineTag,
    textAlign: "left",
    textColor: "content-default"
  }, headline), hasAction && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesPage__body--link"
  }, externalAction && (0, _renderObject.renderObject)(externalAction), !externalAction && /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    variant: "primary"
  }, linkAction))))), subheadline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesPage__footer--subheadline"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "body",
    htmlTag: "p",
    textAlign: "left",
    textColor: "xsubtle"
  }, subheadline))));
};

/**
 * Property type definitions
 * @typedef TitlesPageProps
 * @type {object}
 * @property {object} externalAction - external action object
 * @property {string} headline - headline text of the title
 * @property {string} headlineTag - headline tag of the title
 * @property {object} linkAction - action link for the title
 * @property {string} subheadline - subheadline tag of the title
 */
exports.TitlesPage = TitlesPage;
const propTypes = exports.propTypes = {
  externalAction: _propTypes.default.object,
  headline: _propTypes.default.string,
  headlineTag: _propTypes.default.string,
  linkAction: _propTypes.default.object,
  subheadline: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} headlineTag='h2' - headline tag of the title
 */
const defaultProps = exports.defaultProps = {
  headlineTag: 'h2'
};
TitlesPage.propTypes = propTypes;
var _default = exports.default = TitlesPage;